import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Tag, message } from 'antd';
import { Button, List, SpinLoading } from 'antd-mobile';
import {
    ScheduleOutlined
} from '@ant-design/icons';

import moment from 'moment-timezone';
import 'moment/locale/ru';

import WorkflowAction from '../Workflow'
import Filtered from '../../components/Filtered'
import { CollectionServerMobile, errorCatch, GET, IfElse, POST, publish, QueryOrder, QueryParam, updateArrayInArray, useAuth } from 'fennec-ui';


export default function NotifyBlock(props) {
    const dispatch = useDispatch();
    const auth = useAuth()
    const { filters, compact, uuid } = props;
    const meta = useSelector(state => state.meta);
    const [readallspin, setReadallspin] = useState(false);
    const [spin, setSpin] = useState({});
    // const prochitano = notify.filter(s => !s.prochitano).length > 0;
    const date = (item) => {
        var time = moment(item.CreatedAt).tz("Europe/Moscow").format('DD.MM.YYYY HH:mm');
        if (!item.prochitano) {
            return (
                // <Badge notify="processing" style={{cursor:"pointer"}} onClick={() => action(item, item.tipKnopkaOKDokument)} text={<span style={{ fontSize: "12px", fontWeight: "600"}}>{time}</span>} />
                <div style={{
                    color: "rgba(0, 0, 0, 0.65)",
                    fontSize: "12px", marginTop: "3px", fontWeight: "600", cursor: "pointer"
                }}
                    onClick={() => action(item, "read")}>{time}</div>
            );
        } else {
            return (
                <div style={{
                    color: "rgba(0, 0, 0, 0.65)",
                    fontSize: "12px", marginTop: "3px"
                }}>{time}</div>
            );
        }
    };
    const action = (notify, document, { collection, setCollection }) => {
        setSpin({ ...spin, [notify.ID]: true })
        POST(auth, `/api/notify/read`, notify,
            ({ data }) => {
                if (data.notify) {
                    setCollection(updateArrayInArray(collection, data.notify))
                    publish(`service.notify.${uuid}`, [...data.notify])
                }
                setSpin({ ...spin, [notify.ID]: false });
            }, errorCatch);
    };
    const markAsReaded = (collection, setCollection) => {
        setReadallspin(true);
        var arr = collection.filter(s => !s.prochitano);
        if (arr.length > 0) {
            GET(auth, `/api/notify/read-all`,
                ({ data }) => {
                    setCollection([])
                    // publish(`service.notify.${uuid}`, [])
                    publish(`service.notify.clear`, [])
                    setReadallspin(false);
                }, errorCatch);
        }
    };
    const ui = (item, { collection, setCollection }) => {
        return (
            <div key={item.ID}>
                <div style={{ margin: "0 10px", flexBasis: "85px", color: "rgba(0, 0, 0, 0.45)" }}>{date(item)}</div>
                {item.prochitano && <div style={{ margin: "0 10px", flexBasis: "100%", fontSize: "14px" }}>{item.tekstUvedomleniya}</div>}
                {!item.prochitano && <div style={{ margin: "0 10px", flexBasis: "100%", fontWeight: "600", cursor: "pointer", fontSize: "14px" }} onClick={() => action(item, "read", { collection, setCollection })}>{item.tekstUvedomleniya}</div>}
            </div>
        );
    };
    return (

        <CollectionServerMobile
            // onCollectionChange={(collection) => {
            //     publish(`service.notify.${uuid}`, [...collection])
            //     console.log("publish",`service.notify.${uuid}`);
            // }}
            subscribe={{
                name: "service.notify",
                filter: `service.notify.${uuid}`,
                func: (data, { msg, collection, setCollection, setCollectionItem, removeCollectionItem, request, state }) => {
                    request()
                }
            }}
            noheader={true}
            name={"InfrastrukturnieUvedomleniya"}
            auth={auth}
            size="small"
            source={'/api/query/InfrastrukturnieUvedomleniya'}
            contextFilters={() => [
                QueryOrder("Prochitano", "ASC"),
                QueryOrder("Data", "DESC"),
                IfElse(compact, QueryParam("w-eqOrNu-Prochitano", "false"), undefined),
            ]}
            filters={filters}
            mode={"list"}
            render={(item, idx, { collection, setCollection, setCollectionItem, update }) => {
                return ui(item, { collection, setCollection })
            }}
            collectionActions={() => [{
                mode: "func",
                trigger: (click) => (
                    <>
                        {readallspin && <div style={{
                            width: "100%",
                            minHeight: "150px",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center"
                        }}>
                            <SpinLoading style={{ '--size': '32px' }} />
                        </div>}
                        <Tag style={{ cursor: "pointer", background: "transparent", border: "none", fontSize: "14px" }} onClick={click}>
                            <ScheduleOutlined />
                        </Tag>
                    </>
                ),
                action: (values, unlock, close, { collection, setCollection }) => {
                    markAsReaded(collection, setCollection)
                },
            }]}
        />
    );
}
